<template>
  <main class="grow">
    <slot />
  </main>
</template>
